import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";

import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';

import { PlanMaintenanceTLR } from './plan-maintenance-tlr.entity';
import { PlanMaintenanceCreate } from './plan-maintenance-create.entity';
import { PlanMaintenanceUpdate } from './plan-maintenance-update.entity';

@Injectable({ providedIn: 'root' })
export class PlanMaintenanceService {
	private path: string;

	constructor( //
		@Inject(HttpClient) private httpClient: HttpClient, //
		@Optional() @SkipSelf() previousInstance?: PlanMaintenanceService //
	) {
		if (previousInstance) {
			throw new Error(
				'PlanMaintenanceService is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
	}

	public getByParc(parcId: number): Observable<PlanMaintenanceTLR[]> {
		let url = this.path + 'plan-maintenance/parc/' + parcId + '/plans?format=TLR';
		let result = this.httpClient //
			.get<PlanMaintenanceTLR[]>(url) //
		;

		return result;
	}
	
	public create(command: PlanMaintenanceCreate): Observable<void> {
		const url = this.path + 'plan-maintenance/create-orders';
		const request$ = this.httpClient.post<void>(url, command, {});
		return request$;
	}
	
	public update(command: PlanMaintenanceUpdate): Observable<void> {
		const url = this.path + 'plan-maintenance/update-orders';
		const request$ = this.httpClient.post<void>(url, command, {});
		return request$;
	}
	
	public delete(planId: number): Observable<void> {
		const url = this.path + 'plan-maintenance/' + planId;
		const request$ = this.httpClient.delete<void>(url, {});
		return request$;
	}
}